import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

const ErrorContainer = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    padding: token("space.400")
});

const ErrorHeading = css({
    fontSize: token("font.heading.medium"),
    fontWeight: token("font.weight.bold"),
    marginBlockStart: token("space.200")
});

const ErrorText = css({
    color: token("color.text.subtle")
});

const NotificationError = () => (
    <div css={ErrorContainer}>
        <h3 css={ErrorHeading}>Something went wrong</h3>
        <p css={ErrorText}>
            We can’t load any more notifications right now, please try again
            later
        </p>
    </div>
);

export default NotificationError;
